import { motion } from "motion/react";
import { Target, Lightbulb, Rocket } from "lucide-react";

export function EmpresaPage() {
  return (
    <div className="min-h-screen bg-white pt-20">
      <section className="py-24 px-6 bg-gradient-to-br from-gray-50 to-white">
        <div className="max-w-7xl mx-auto text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
          >
            <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">
              Transformando operações complexas em<br />
              <span className="bg-gradient-to-r from-green-600 to-blue-600 bg-clip-text text-transparent">
                ecossistemas digitais inteligentes
              </span>
            </h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              A BusiFarm nasceu para revolucionar a gestão empresarial através de tecnologia de ponta e inovação constante
            </p>
          </motion.div>
        </div>
      </section>

      <section className="py-24 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
            {[
              {
                icon: Target,
                title: "Missão",
                desc: "Desenvolver plataformas tecnológicas que transformam operações empresariais complexas em processos inteligentes, automatizados e escaláveis."
              },
              {
                icon: Lightbulb,
                title: "Visão",
                desc: "Ser referência em inovação tecnológica para gestão empresarial, liderando a transformação digital de múltiplos segmentos operacionais."
              },
              {
                icon: Rocket,
                title: "Propósito",
                desc: "Capacitar empresas com tecnologia de ponta para que possam escalar suas operações com inteligência, eficiência e sustentabilidade."
              },
            ].map((item, index) => (
              <motion.div
                key={index}
                className="text-center"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.2 }}
              >
                <div className="w-16 h-16 bg-gradient-to-br from-green-500 to-blue-500 rounded-2xl flex items-center justify-center mx-auto mb-6">
                  <item.icon className="w-8 h-8 text-white" />
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">{item.title}</h3>
                <p className="text-gray-600 leading-relaxed">{item.desc}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-24 px-6 bg-gradient-to-br from-gray-900 to-gray-800 text-white">
        <div className="max-w-4xl mx-auto text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <h2 className="text-4xl md:text-5xl font-bold mb-6">
              Nossa jornada de inovação
            </h2>
            <p className="text-xl text-gray-300">
              Começamos no agronegócio industrial, especialmente na avicultura, onde desenvolvemos expertise profunda
              em operações complexas. Hoje, nossa arquitetura cloud-native e nosso conhecimento em gestão empresarial
              nos permitem atender múltiplos segmentos com a mesma excelência tecnológica.
            </p>
          </motion.div>
        </div>
      </section>

      <section className="py-24 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              Inovação em <span className="text-green-600">números</span>
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {[
              { value: "12M+", label: "Registros processados" },
              { value: "2TB+", label: "Dados gerenciados" },
              { value: "99.9%", label: "Uptime garantido" },
            ].map((stat, i) => (
              <motion.div
                key={i}
                className="text-center"
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.1 }}
              >
                <div className="text-4xl md:text-5xl font-bold text-green-600 mb-2">{stat.value}</div>
                <div className="text-gray-600">{stat.label}</div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
